import error from '../common/error';
import logreg from '../js/logreg';
import notice from '../common/notice';
import title from '../common/title';
import desc from '../common/desc';
import passwordInput from '../common/password';
import codeInput from '../common/code';
import button from '../common/button';
import toast from '../common/toast';
export default {
  name: 'regwrap',
  props: {
    name: {
      type: String,
      default: ''
    },
    wayType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      password: '',
      code: '',
      codeError: '',
      passwordError: '',
      cover: false,
      toastState: false,
      txt: ''
    };
  },
  computed: {
    actBtn: function actBtn() {
      return !!this.code && !this.codeError && !!this.password && !this.passwordError;
    }
  },
  components: {
    'error-tip': error,
    'desc-txt': desc,
    'title-txt': title,
    'notice-txt': notice,
    'password-input': passwordInput,
    'code-input': codeInput,
    'button-wrap': button,
    'toast-pop': toast
  },
  methods: {
    changeCodeErrorHandle: function changeCodeErrorHandle(txt) {
      this.codeError = txt;
    },
    changeCodeHandle: function changeCodeHandle(code) {
      this.code = code;
    },
    changePasswordHandle: function changePasswordHandle(password) {
      this.password = password;
    },
    changePasswordErrorHandle: function changePasswordErrorHandle(txt) {
      this.passwordError = txt;
    },
    send: function send() {
      var _this = this;
      if (this.code && this.password && !this.passwordError && !this.codeError && !this.cover) {
        this.cover = true;
        logreg.register(this.name, this.password, this.code, '', '', logreg.REGTYPE.email, 1, function (state, data) {
          _this.cover = false;
          if (state === 'tongdun_fail') {
            _this.showPop('Network error,refresh retry');
            return;
          }
          if (state === 'success') {
            _this.$emit('success', data);
          } else if (window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf("".concat(data.status)) >= 0 || window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf(data.data && "".concat(data.data.status)) >= 0) {
            // this.codeError = this.$t(this.$loginLangPrefix('userSign.fkError'));
          } else if (data.data && data.data.status === '4044') {
            _this.$emit('inputEmail', 'sure', _this.name, data.accessToken);
          } else if (data.errorMessageTMXTip) {
            //
          } else {
            if (_this.$refs.codeinput) {
              _this.$refs.codeinput.getVerify();
            }
            _this.codeError = _this.$t(_this.$loginLangPrefix('userSign.codeError'));
          }
        });
      }
    },
    gotoLogin: function gotoLogin() {
      this.$emit('inputEmail', 'input', '', '');
    },
    showPop: function showPop(txt) {
      var _this2 = this;
      this.txt = txt;
      this.toastState = true;
      setTimeout(function () {
        _this2.txt = '';
        _this2.toastState = false;
      }, 1500);
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};